// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

// Utils
import {
    getNotificationBoardTitle,
    getNotificationElementChangeCount,
    getNotificationElementId,
    getNotificationShareTimestamp,
} from '../../../../../../../common/notifications/notificationModelUtils';
import { getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import friendlyTimeFormatter from '../../../../../../../common/utils/datetime/friendlyTimeFormatter';

// Components
import BaseNotificationEntry from './BaseNotificationEntry';
import UserNames from './UserNames';
import NotificationUserFigure from './NotificationFigureUser';
import Icon from '../../../../../../components/icons/Icon';
import NotificationElementChangeSummary from './NotificationElementChangeSummary';

const BoardTitle = (props) => {
    const { group, element, notification } = props;

    const groupId = get('id', group);
    const boardId = getNotificationElementId(notification);

    if (groupId === boardId) return <span>this board</span>;

    const boardTitle = getTitle(element) || getNotificationBoardTitle(notification);

    if (!boardTitle) return <span>a board</span>;

    return <span className="board-title">{boardTitle}</span>;
};

const NotificationEntryShareReminder = (props) => {
    const { shareActor, notification } = props;

    const changeCount = getNotificationElementChangeCount(notification);

    const shareTimestamp = getNotificationShareTimestamp(notification);
    const friendlyShareTime = friendlyTimeFormatter({ timestamp: shareTimestamp, showSuffix: true });

    return (
        <BaseNotificationEntry
            {...props}
            className="NotificationEntryShareReminder"
            figure={<NotificationUserFigure {...props} icon={<Icon name="notification-share" />} />}
        >
            <div className="notification-statement">
                <UserNames users={[shareActor]} /> shared <BoardTitle {...props} /> with you {friendlyShareTime}
                {changeCount ? ' and has made these changes since:' : ''}
            </div>
            <NotificationElementChangeSummary {...props} />
        </BaseNotificationEntry>
    );
};

BoardTitle.propTypes = NotificationEntryShareReminder.propTypes = {
    element: PropTypes.object,
    group: PropTypes.object,
    shareActor: PropTypes.object,
    notification: PropTypes.object,
    previousLastCheckedNotifications: PropTypes.number,
};

export default NotificationEntryShareReminder;
